import React, { useEffect, useRef, useState } from "react";
import "./ServiceBoxes.css";

const services = [
  {
    href: "/webbutveckling",
    title: "Kunskap anpassad efter Dina Behov från Centrum För alla",
    description:
      "Vi bygger och utvecklar webbplatser uteslutande utifrån dina krav och specifikationer från designidéer till funktionella behov och innehåll, garanterar 100% anpassad för din verksamhet.",
  },
  {
    href: "/digitalmarknadsforing",
    title: "Driv Din Verksamhet Framåt med Rätt Digital Marknadsföring",
    description:
      "Med våra datadrivna strategier och kreativt tänkande hjälper vi din verksamhet att sticka ut online. Vi når rätt målgrupp vid rätt tidpunkt från sociala medier till PPC och beyond.",
  },
  {
    href: "/seo",
    title: "Fånga Din Publik med SEO som Gör Skillnad",
    description:
      "Vi tar din webbplats till toppen av sökresultaten med skräddarsydd SEO som engagerar och omvandlar. Mer synlighet, mer trafik, och fler kunder allt organisk, inget fluff.",
  },
];

const ServiceBoxes = () => {
  const boxesRef = useRef([]);
  const [hoveredIndex, setHoveredIndex] = useState(null); // State to track hover

  const isInViewport = (element, offset = 100) => {
    const rect = element.getBoundingClientRect();
    return (
      rect.top + offset >= 0 &&
      rect.left >= 0 &&
      rect.bottom - offset <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };

  const handleScroll = () => {
    boxesRef.current.forEach((box) => {
      if (isInViewport(box, 200)) {
        box.classList.add("active");
      } else {
        box.classList.remove("active");
      }
    });
  };

  useEffect(() => {
    const currentBoxes = boxesRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    currentBoxes.forEach((box) => {
      if (box) observer.observe(box);
    });

    return () => {
      currentBoxes.forEach((box) => {
        if (box) observer.unobserve(box);
      });
    };
  }, []);
  const handleButtonClick = (href) => {
    window.location.href = href;
  };
  return (
    <div className="services-section-after-hero">
      <div className="services-boxes-after-hero">
        {services.map((service, index) => (
          <div
            key={index}
            className={`service-card color-${index % 3}`}
            ref={(el) => (boxesRef.current[index] = el)}
          >
            <h2 className="service-h2">{service.title}</h2>
            <p className="description-after-hero">{service.description}</p>
            <div className="read-more-link">
              {service.href && (
                <button
                  onClick={() => handleButtonClick(service.href)}
                  className="read-more-button"
                >
                  Läs mer
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceBoxes;
